import { useCallback, useEffect, useState } from "react";
import { fetchStorages, updateStorage, deleteStorage } from "../../../services/service.service";

const INITIAL_STORAGE = {
    id_company: "",
    id_warehouse: "",
    id_product_service: "0",
    price: "",
    cost: "",
    profit: "",
    taxes: "",
    location: "",
    stock: "",
    stock_max: "",
    stock_min: "",
    discount: "",
};

export const useStorageManager = (idProductService, token, isEdit) => {
    const [storageList, setStorageList] = useState([]);
    const [editingItem, setEditingItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadStorages = useCallback(async () => {
        if (!idProductService || !isEdit) return;
        setLoading(true);
        try {
            const response = await fetchStorages(idProductService, token);
            if (response.data?.length > 0) {
                setStorageList(response.data);
            }
        } catch (e) {
            console.error("Error fetching storages:", e.message);
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }, [idProductService, token, isEdit]);

    useEffect(() => {
        loadStorages();
    }, [loadStorages]);

    const handleEdit = useCallback((id) => {
        const item = storageList.find((s) => s.id === id);
        if (item) setEditingItem({ ...item });
    }, [storageList]);

    const handleEditChange = useCallback((field, value) => {
        setEditingItem((prev) => prev ? { ...prev, [field]: value } : prev);
    }, []);

    const handleEditSave = useCallback(async () => {
        if (!editingItem) return;
        setLoading(true);
        try {
            await updateStorage(editingItem.id, editingItem, token);
            setStorageList((prev) => prev.map((s) => (s.id === editingItem.id ? { ...editingItem } : s)));
            setEditingItem(null);
        } catch (e) {
            console.error("Error updating storage:", e.message);
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }, [editingItem, token]);

    const handleEditCancel = useCallback(() => {
        setEditingItem(null);
    }, []);

    const handleDelete = useCallback(async (id) => {
        const confirmed = window.confirm("¿Estás seguro de que deseas eliminar esta bodega?");
        if (!confirmed) return;
        setLoading(true);
        try {
            await deleteStorage(id, token);
            setStorageList((prev) => prev.filter((s) => s.id !== id));
        } catch (e) {
            console.error("Error deleting storage:", e.message);
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }, [token]);

    return {
        storageList,
        editingItem,
        loading,
        error,
        INITIAL_STORAGE,
        handleEdit,
        handleEditChange,
        handleEditSave,
        handleEditCancel,
        handleDelete,
        reload: loadStorages,
    };
};